// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"207":"updates","594":"about","964":"product"}[chunkId] + "." + {"207":"0e4f2af8","594":"c98d0bdc","964":"811f27c7"}[chunkId] + ".css";
};